import state from "@/store/modules/banner/state";
import actions from "@/store/modules/banner/actions";
import mutations from "@/store/modules/banner/mutations";
import getters from "@/store/modules/banner/getters";


export default {
  state,
  actions,
  mutations,
  getters
}